import React from "react";

import { UrlizeOpts, urlizeUrl } from "@/mk/bazaar/common/filters/urlize";
import { TextLike, reactFilter } from "@/mk/bazaar/common/filters/utils";

// Markdown-style inline link: [visible text](https://url?with=utm)
// Only http(s)/www URLs are linkified; the visible text may be anything but `]`.
// The href (incl. query/UTM) is kept intact; the custom label is shown as-is.
const MD_LINK_RE = /\[([^\]]+)]\((https?:\/\/[^)\s]+|www\.[^)\s]+)\)/;

// Render markdown links as real <a> elements, reusing urlizeUrl so the
// rel/target/internal-vs-external handling matches bare-URL links.
export const mdLinkize = (text: TextLike, opts?: UrlizeOpts) =>
    reactFilter(text, (s: string): React.ReactChild[] => {
        const ret: React.ReactChild[] = [];
        const matcher = new RegExp(MD_LINK_RE, "g");
        let from = 0;
        while (true) {
            const match = matcher.exec(s);
            if (match) {
                const matchLen = match[0].length;
                const label = match[1];
                const linkUrl = match[2];
                const to = matcher.lastIndex - matchLen;

                // copy text before this link
                ret.push(s.substring(from, to));

                // 0 trim limit + explicit label => full custom text shown, href intact
                ret.push(urlizeUrl(linkUrl, 0, opts, label));

                from = matcher.lastIndex;
            } else {
                // copy text after last link
                ret.push(s.substring(from));
                break;
            }
        }
        return ret;
    });
